import "bootstrap/dist/css/bootstrap.min.css";
import React, {useEffect} from 'react';
import { useTranslation } from "react-i18next";
import { Form } from 'react-bootstrap';
import i18n from '../../i18n';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    logoHeader: {
        width: "100%",
        backgroundColor: "white",
        color: "black",
        height: "90px",
        borderTop: "3px solid #f15a23",
        padding: "5px 0",
        marginBottom: "20px"
    }
}));

function EDMHeader({props}) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { allowChangeLang = true } = props;

    useEffect(() => {
        document.title = t("EDM.KGIMarketUpdateSubscription");
    }, []);

    function changeLang(e) {
        i18n.changeLanguage(e.target.value);
        document.title = t("EDM.KGIMarketUpdateSubscription");
    }

    return (
        <div className={classes.logoHeader}>
            <div style={{display: "flex"}}>
                <div style={{float: "left", width: "50%", textAlign: "left"}}>
                    <img src={`${process.env.REACT_APP_ROUTER_BASE_URL}/media/KGI-logo.png`} style={{width: "100px"}} alt="logo"></img>
                </div>
                <div style={{float: "right", textAlign: "right", width: "200px", paddingRight: "5px", marginLeft: "auto", marginRight: "0"}}>
                    <img src={`${process.env.REACT_APP_ROUTER_BASE_URL}/media/logo_groupMemberCDF.png`}  alt="logo"></img>
                </div>
            </div>
            <div style={{display: "flex"}}>
                {allowChangeLang &&
                    <div style={{float: "right", textAlign: "right", paddingRight: "5px", marginLeft: "auto", marginRight: "0"}}>
                        <Form.Select name="lang" onChange={e => changeLang(e)} value={i18n.language.toUpperCase()} style={{width: "120px"}}>
                            <option value="EN">English</option>
                            <option value="CHT">繁體</option>
                        </Form.Select>
                    </div>
                }
            </div>
        </div>
    )
}

export default EDMHeader;